<template>
  <a-row type="flex" justify="center" align="middle" style="min-height:92px;">
    <a-col :xs="0" :sm="0" :md="0" :xl="12" v-if="currentRobot && showInfo">
      <a-spin :spinning="RobotInfoLoading">
        <a-row class="robot-info" type="flex">
          <a-col>
            <a-avatar class="avatar" icon="user" :size="72" :src="currentRobot.wx_avatar" />
          </a-col>
          <a-col :style="{ flex: '1' }">
            <div class="title">
              {{ currentRobot.nickname }}
              <a-button @click="getRobotInfo" :style="{ marginLeft: '10px' }" size="small"><a-icon type="sync" /></a-button>
            </div>
            <div>
              微信ID：{{ currentRobot.wx_id }}
              <!-- <a-divider type="vertical" />
                余额：{{currentRobot.credit | currency('￥')}} -->
              <!-- <a-divider type="vertical" /> 
                到期时间：{{currentRobot.time*1000 | moment}} -->
            </div>
          </a-col>
        </a-row>
      </a-spin>
    </a-col>
    <a-col :sm="24" :md="12">
      <a-row type="flex" justify="center">
        <a-col :sm="24" :lg="18">
          <div v-show="mgMovieFlag" class="global-search-wrapper">
            <a-input-group compact style="display: inline-flex;">
              <a-select v-model="queryParam.type">
                <a-select-option value="3">微信昵称</a-select-option>
                <a-select-option value="2">微信ID</a-select-option>
                <a-select-option value="1">机器人编号</a-select-option>
              </a-select>
              <a-auto-complete class="global-search" @select="onSelect" @search="handleSearch" v-model="SearchValue"
                placeholder="关键字" optionLabelProp="value">
                <template slot="dataSource">
                  <a-select-option :key="'loading'" v-if="SearchLoading">
                    <a-spin size="small" />
                  </a-select-option>
                  <a-select-option class="search-source" v-else v-for="(item) in dataSource"
                    :key="item.id + ''">ID：{{ item.id }}，昵称：{{ item.nickname || '未设置' }}</a-select-option>
                  <!-- <a-select-option
                    v-else-if="queryParam.type == 3"
                    v-for="item in dataSource"
                    :key="item.nickname + ' ID：' + item.id"
                  >
                    ID：{{ item.id }}，昵称：{{ item.nickname || '未设置' }}
                  </a-select-option>
                  <a-select-option v-else-if="queryParam.type == 1" v-for="item in dataSource" :key="item.id + ''">
                    ID：{{ item.id }}，昵称：{{ item.nickname || '未设置' }}
                  </a-select-option>
                  <a-select-option
                    v-else-if="queryParam.type == 2"
                    v-for="item in dataSource"
                    :key="item.wx_id + ' ID：' + item.id"
                  >
                    ID：{{ item.id }}，昵称：{{ item.nickname || '未设置' }}
                  </a-select-option> -->
                </template>
                <a-input>
                  <a-button slot="suffix" @click="handleSearch(SearchValue)" class="search-btn"
                    type="primary">{{ primaryBtnText }}</a-button>
                </a-input>
              </a-auto-complete>
            </a-input-group>
          </div>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import DeviceApi from '@/api/device'
const DetailListItem = DetailList.Item
export default {
  components: {
    DetailList,
    DetailListItem
  },
  props: {
    // 是否显示机器人信息
    showInfo: {
      type: Boolean,
      default: true
    },
    // 是否自动选取第一个机器人
    selectFirst: {
      type: Boolean,
      default: true
    },
    // 确认按钮文案
    primaryBtnText: {
      type: String,
      default: '搜索机器人'
    },
    // 订单管理-芒果电影票-不需要展示“筛选机器人”
    mgMovieFlag: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 查询参数
      queryParam: {
        type: '3'
      },
      dataSource: [],
      SearchValue: null,
      SearchLoading: false,
      RobotInfoLoading: false,
      currentRobotId: null,
      currentRobot: null,
      robotName: '',
    }
  },
  created() {
    this.getData()
  },
  watch: {
    currentRobotId(newVal) {
      this.getRobotInfo()
      // console.log(1,this.robotName)
      this.$emit("changeRobotId", newVal, this.robotName)
    },
    currentRobot(newVal) {
      // console.log("currentRobot",newVal);
      // 此emit事件，第一个参数必须是机器人的id，第二个参数必须是机器人的nickname
      this.$emit("changeRobotId", newVal.id, newVal.nickname)
    }
  },
  methods: {
    onSelect(value) {
      this.currentRobotId = value
      // if (this.queryParam.type == 3) {
      //   const arr = this.dataSource.filter((item) => {
      //     return value == item.nickname + ' ID：' + item.id
      //   })
      //   this.currentRobotId = arr[0].id
      // } else if (this.queryParam.type == 2) {
      //   const arr = this.dataSource.filter((item) => {
      //     return value == item.wx_id + ' ID：' + item.id
      //   })
      //   this.currentRobotId = arr[0].id
      // } else {
      //   this.currentRobotId = value
      // }
    },

    handleSearch(value) {
      this.$emit("changeRobotId", this.currentRobotId, this.robotName)
      // 根据左边的下拉框，在右边的下拉框选择值筛选
      // if (this.queryParam.type != 1) {
      // value = value.split(' ID：')[0]
      // }
      this.getData(value)
    },

    getData(keywords = '') {
      const type = this.queryParam.type
      this.SearchLoading = true
      DeviceApi.getList({ type: type, keywords: keywords, sortField: 'id', sortOrder: 'ascend' }).then((res) => {
        this.dataSource = res.data
        // 获取机器人名称
        // console.log("dataSource=",this.dataSource);
        this.robotName = res.data[0].nickname
        if (!this.currentRobotId && this.dataSource[0] && this.selectFirst) {
          this.currentRobotId = this.dataSource[0].id + ''
        }
      }).finally(() => {
        this.SearchLoading = false
      })
    },

    getRobotInfo() {
      const currentRobotId = this.currentRobotId
      this.RobotInfoLoading = true
      DeviceApi.getSettingInfo({ id: currentRobotId }).then((res) => {
        if (res.code === 1) {
          this.currentRobot = res.data.robot_info
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.RobotInfoLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 16px;
  -webkit-box-flex: 1;
  flex: auto;
}

.robot-info {
  background: #fff;
  border-radius: 5px;

  .avatar {
    margin-right: 24px;
    margin-bottom: 16px;
    // margin-top: 10px;
  }
}

/deep/ .global-search-wrapper {
  padding-right: 50px;
  margin-top: -8px;
}

/deep/ .global-search {
  width: 100%;
  height: 40px;
}

/deep/ .global-search.ant-select-auto-complete .ant-select-selection--single {
  margin-right: -46px;
}

/deep/ .global-search.ant-select-auto-complete .ant-input-affix-wrapper .ant-input:not(:last-child) {
  padding-right: 112px;
}

/deep/ .global-search.ant-select-auto-complete .ant-input-affix-wrapper .ant-input-suffix {
  right: 0px;
}

/deep/ .global-search.ant-select-auto-complete .ant-input-affix-wrapper .ant-input-suffix button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/deep/ .global-search-item-count {
  position: absolute;
  right: 16px;
}
</style>
